var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTickets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.692 2.808v10.384M.5 10.826v0c0-.274.193-.51.462-.565h0a2.308 2.308 0 000-4.523v0A.576.576 0 01.5 5.174v-1.79 0c0-.318.258-.576.577-.576h13.846v0c.319 0 .577.258.577.577v1.789c0 .274-.193.51-.462.564h0a2.308 2.308 0 000 4.524v0c.269.054.462.29.462.564v1.79a.577.577 0 01-.577.576H1.077v0a.577.577 0 01-.577-.577v0-1.789z",
    stroke: "#586069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgIconTickets;